import { Alert } from "@material-ui/lab";
import React from "react";
import { makeThemedStyles } from "./../../viewcomponents/utils";

const useAlertStyles = makeThemedStyles("alertStyles", (theme) => ({
  default: {
    fontSize: "12px",
    fontFamily: "Roboto, Helvetica, Arial",
    borderRadius: "18px",
    paddingLeft: "10px",
    minWidth: "170px",
    marginBottom: "0px",
    "& svg": {
      fontSize: "18px",
      marginTop: 0,
      marginRight: 0,
    },
  },
  info: {
    backgroundColor: "rgb(232, 244, 253)",
  },
  error: {},
  success: {},
  warning: {},
  completedTask: { minWidth: "100px" },
}));

const AlertMessage: React.FC<{
  severity: "error" | "info" | "success" | "warning";
  icon?: React.ReactNode;
  className?: string;
}> = (props) => {
  const classes = useAlertStyles();
  const classObj =
    classes[(props.className || props.severity) as keyof typeof classes] ||
    classes["default"];

  return (
    <Alert
      severity={props.severity}
      icon={props.icon}
      className={classObj}
      classes={{ root: classes.default }}
    >
      {props.children}
    </Alert>
  );
};
export default AlertMessage;
